import React from "react"
import PropTypes from "prop-types"
import { Box, Typography } from "@mui/material"
import DataGridTable from "src/v2/components/Table/data-grid-table"
import ButtonWithIcon from "src/v2/components/Button/Button"
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded"
import theme from "src/v2/theme/theme"

const CadastroLoteTable = ({
    title = "ÚLTIMAS IMPORTAÇÕES",
    rows = [],
    columns = [],
    loading = false,
    onReload,
}) => {
    return (
        <Box sx={{ mt: 2 }}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                }}
            >
                <Typography
                    sx={{
                        color: theme.palette.primary.contrastText,
                        fontWeight: 700,
                    }}
                >
                    {title}
                </Typography>

                {onReload && (
                    <ButtonWithIcon
                        size="sm"
                        icon={<RefreshRoundedIcon />}
                        onClick={onReload}
                    />
                )}
            </Box>

            <DataGridTable
                rows={rows}
                columns={columns}
                loading={loading}
                autoRowHeight
                pageSize={25}
                showPagination={rows.length > 0}
                disableRowSelectionOnClick
            />
        </Box>
    )
}

CadastroLoteTable.propTypes = {
    title: PropTypes.string,
    rows: PropTypes.array,
    columns: PropTypes.array.isRequired,
    loading: PropTypes.bool,
    onReload: PropTypes.func,
}

export default CadastroLoteTable